module.exports = "/static/media/rightArrow_icon.d76b6465.svg";